import { useState } from 'react';

import { IRequestTableModeConfig } from './types';
import { useRequestGroups } from '../../../domains/request-group/request-group.service';
import { Button } from '../../../_core/button/button.component';
import { RIDialog } from '../../../_core/dialog/dialog.component';
import { RequestGroupTable } from './request-group-table.component';
import { EditRequestGroupContainer } from '../../../domains/request-group/edit/edit-request-group.container';

export const RequestGroupTableContainer = ({ modeConfig }: { modeConfig: IRequestTableModeConfig }) => {
  const { requestGroups, loading: groupsLoading } = useRequestGroups({ includeArchived: true });

  const [createRequestGroup, setCreateRequestGroup] = useState(false);

  return (
    <>
      <RequestGroupTable groups={requestGroups} modeConfig={modeConfig} loading={groupsLoading}>
        <Button onClick={() => setCreateRequestGroup(true)} text="Create Bulk Request" size="large" className="mt-1" />
      </RequestGroupTable>
      <RIDialog open={createRequestGroup} setOpen={setCreateRequestGroup}>
        <EditRequestGroupContainer />
      </RIDialog>
    </>
  );
};
